import { useTranslation } from '@/hooks/useTranslation';
import { useToast } from '@/components/layout/Toast';
import { useState } from 'react';
import {
  AdminEnterprisesWithLicenseScreenDocument,
  AdminEnterprisesWithoutLicenseScreenDocument,
  useCompanyDeleteMutation,
} from '@/graphql/generated';
import {
  ConfirmationModalType,
  useConfirmationModal,
} from '@/components/modals/ConfirmationModal';
import { Loader } from '@/components/generic/Loader';
import consultingCompanyApi from '@/slices/consultingCompany/consultingCompany.api';

export function DeleteCompanyButton({ companyId }: { companyId: string }) {
  const { t } = useTranslation();
  const toast = useToast();
  const { openConfirmationModal } = useConfirmationModal();
  const [isDeleting, setIsDeleting] = useState(false);

  const [deleteCompanyMutation] = useCompanyDeleteMutation();
  const [refetchConsultingCompany] =
    consultingCompanyApi.endpoints.getConsultingCompanies.useLazyQuery();

  const deleteCompany = () => {
    setIsDeleting(true);
    deleteCompanyMutation({
      variables: {
        companyId: companyId,
      },
      refetchQueries: [
        AdminEnterprisesWithLicenseScreenDocument,
        AdminEnterprisesWithoutLicenseScreenDocument,
      ],
    })
      .then(() => refetchConsultingCompany())
      .then(() => {
        toast.openToastWithMessage(t('admin:companies.toast.company_deleted'));
      })
      .catch((err) => {
        toast.openToastWithError(err.message);
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  return (
    <button
      className="primary danger small"
      disabled={isDeleting}
      onClick={() =>
        openConfirmationModal({
          titleBar: t('global:delete'),
          description: t('project.delete.content'),
          callbackIfConfirmed: deleteCompany,
          type: ConfirmationModalType.Danger,
        })
      }
    >
      {isDeleting && <Loader />}
      <div>{t('global:delete')}</div>
    </button>
  );
}
